import React from 'react';

import TableHeader from '@dashboard/components/table/TableHeader';
import { useSetCurrentPage } from '@dashboard/hooks/route/useCurrentPage';

type Props = {
  title: JsxNode | string;
  actions?: JsxNode;
  titleActions?: JsxNode;
  pagination?: {
    page: number;
    limit: number;
    count: number;
  };
};

export default function Header({ pagination, ...restProps }: Props) {
  const setPage = useSetCurrentPage();

  const props = {
    setPage,
    ...restProps,
  };

  if (!pagination) {
    return <TableHeader {...props} />;
  }
  const { page, limit, count } = pagination;
  return <TableHeader currentPage={page} limit={limit} count={count} {...props} />;
}
